import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import { useLoading } from '../../commons/Loading';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import variables from '../../variables';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';
import Footer from '../../commons/Footer';
import { withRouter } from 'react-router-dom';
import './ProfileDetail.scss';
import './TabsProfile.scss';
import MySignalsCondos from './SignalsCondo';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import MySignalsSpecialJobs from './SignalsSpecialJobs';
import MySignalsRentalsSales from './SignalsRentalsSales';
import { ADMIN_TYPES } from '../../App';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const MySignals = ({ profile, match = {}, location }) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const { url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [signals, setSignals] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    signalman: withDefault(StringParam, ''),
    condo: withDefault(StringParam, ''),
    accountabilityYear: NumberParam,
    accountabilityMonth: NumberParam,
    signalTypeCode: withDefault(StringParam, 'CONDO'),
    notes: withDefault(StringParam, ''),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const {
    signalman,
    condo,
    accountabilityYear,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
    notes,
  } = query;

  const fetchSignals = async () => {

    console.log("============");
    console.log("profile:", profile);
    console.log("============");
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signals/received/${profile.type !== 'ADMIN_COLLAB' ? profile._id : profile.adminId}`,
      {
        headers: { Authorization: newToken },
        params: {
          signalman,
          condo,
          accountabilityYear,
          accountabilityMonth,
          signalTypeCode,
          limit,
          offset,
          notes,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setSignals(data.signals || []);
    setTotal(+headers['x-total-count']);
  };

  function onFilter(queryDiff) {
    if (
      (queryDiff.signalman && queryDiff.signalman !== signalman) ||
      (signalman && queryDiff.signalman === '') ||
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      (accountabilityYear && queryDiff.accountabilityYear === '') ||
      (queryDiff.accountabilityMonth &&
        queryDiff.accountabilityMonth !== accountabilityMonth) ||
      (accountabilityMonth && queryDiff.accountabilityMonth === '') ||
      (queryDiff.signalTypeCode &&
        queryDiff.signalTypeCode !== signalTypeCode) ||
      (signalTypeCode && queryDiff.signalTypeCode === '') ||
      (queryDiff.condo && queryDiff.condo !== condo) ||
      (condo && queryDiff.condo === '') ||
      (queryDiff.notes && queryDiff.notes !== notes) ||
      (notes && queryDiff.notes === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  useEffect(() => {
    fetchSignals();
  }, [
    signalman,
    condo,
    accountabilityYear,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
    notes,
  ]);

  if (pathname === url) {
    if ((ADMIN_TYPES.includes(profile.type) || profile.superCollab === true)) {
      return <Redirect to={`${url}/condos`} />;
    } else if (
      ['SUPPLIER', 'EON_ENERGY', 'ASSOCIATION', 'COMMERCIAL'].includes(
        profile.type
      )
    ) {
      return <Redirect to={`${url}/special-jobs`} />;
    } else if (['AGENCY', 'COMMERCIAL', 'ASSOCIATION'].includes(profile.type)) {
      return <Redirect to={`${url}/rentals-sales`} />;
    }
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:MY_SIGNALS_RECEIVED')}
            icon={<IcnDocument fill={variables.white} />}
          />
        </section>
        <section>
          <div className="m-tb-20">
            <Nav tabs>
              {(ADMIN_TYPES.includes(profile.type) || profile.superCollab === true) && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/condos?signalTypeCode=CONDO`}
                    className={classNames({ active: tab === 'condos' })}
                  >
                    {t('PAGES:SIGNALS_CONDO_TAB')}
                  </NavLink>
                </NavItem>
              )}

              {['SUPPLIER', 'EON_ENERGY', 'ASSOCIATION', 'COMMERCIAL'].includes(
                profile.type
              ) && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/special-jobs?signalTypeCode=SPECIAL_JOBS`}
                    className={classNames({ active: tab === 'special-jobs' })}
                  >
                    {t('PAGES:SIGNALS_SPECIAL_JOBS_TAB')}
                  </NavLink>
                </NavItem>
              )}

              {['AGENCY', 'COMMERCIAL', 'ASSOCIATION'].includes(
                profile.type
              ) && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/rentals-sales?signalTypeCode=RENTALS_SALES`}
                    className={classNames({ active: tab === 'rentals-sales' })}
                  >
                    {t('PAGES:SIGNALS_RENTALS_SALES_TAB')}
                  </NavLink>
                </NavItem>
              )}
            </Nav>

            <Switch>
              <Route
                path={`${match.url}/condos`}
                component={(props) => (
                  <MySignalsCondos
                    signals={signals}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/special-jobs`}
                component={(props) => (
                  <MySignalsSpecialJobs
                    signals={signals}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/rentals-sales`}
                component={(props) => (
                  <MySignalsRentalsSales
                    signals={signals}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default withRouter(MySignals);
